import { useSearch, useNavigate } from "@tanstack/react-router";
import { indexRoute } from "../../../routes";

export const BOTTOM_VIEWS = ["algos", "trades"] as const;

export type BottomView = (typeof BOTTOM_VIEWS)[number];

const isBottomView = (value: string | undefined): value is BottomView =>
  BOTTOM_VIEWS.includes(value as BottomView);

/**
 * Which grid the lower half of the app shows. In the URL, like `tag` and
 * `algosArea`, so a reload or a shared link lands on the same view.
 */
export const useBottomView = () => {
  const { bottomView } = useSearch({ from: indexRoute.id });
  const navigate = useNavigate({ from: indexRoute.id });

  const setBottomView = (value: BottomView) => {
    navigate({
      search: (prev) => ({
        ...prev,
        // The default stays out of the URL.
        bottomView: value === "algos" ? undefined : value,
      }),
    });
  };

  return [isBottomView(bottomView) ? bottomView : "algos", setBottomView] as const;
};
